import React, { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';

function ErrorToast({ message, setMessage }) {
  useEffect(() => {
    if (message !== '') {
      toast.error(message, {
        position: "top-center",
        autoClose: 700
      });
      setMessage('');
    }
  }, [message]);

  return (
    <>
      <div>
        <ToastContainer />
      </div>
    </>
  );
}

export default ErrorToast;
